import React, { Suspense, lazy } from 'react';
import { Router, Location, Redirect } from '@reach/router';
import ScrollToTopBtn from './menu/ScrollToTop';
import Loader from './menu/loader';
import Header from './menu/header';
import Footer from './components/footer';

const Home = lazy(() => import('./pages/home'));
const About = lazy(() => import('./pages/about'));
const Service = lazy(() => import('./pages/service'));
const Service1 = lazy(() => import('./pages/service1'));
const Service2 = lazy(() => import('./pages/service2'));
const Contact = lazy(() => import('./pages/contact'));

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return children;
};

const PosedRouter = ({ children }) => (
  <Location>
    {({ location }) => (
      <div id="routerhang">
        <div key={location.key}>
          <Loader />
          <Router location={location}>{children}</Router>
        </div>
      </div>
    )}
  </Location>
);

export default () => (
  <div className="wraper">
    <Header />
    <Suspense fallback={<Loader />}>
      <PosedRouter>
        <ScrollTop path="/">
          <Home exact path="/">
            <Redirect to="/home" />
          </Home>
          <About path="/about" />
          <Service path="/services" />
          <Service1 path="/service1" />
          <Service2 path="/service2" />
          <Contact path="/contact" />
        </ScrollTop>
      </PosedRouter>
    </Suspense>
    <ScrollToTopBtn />
    <Footer />
  </div>
);
